import '../Login/Login.scss';
import './WeeklyActivity.scss';
import Component from './WeeklyActivity.js';
export default Component;
